var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8957 15.6153C24.8957 15.8846 24.6937 16.1153 24.4916 16.1153H24.33C24.0875 16.1153 23.9258 15.8846 23.9258 15.6153V13.8846L22.7943 13.923C22.7135 13.923 22.6327 13.8461 22.6327 13.7307C22.6327 13.6153 22.7135 13.5384 22.7943 13.5384L23.9663 13.5V13.1923C23.9663 12.923 24.1683 12.6923 24.3704 12.6923H24.532C24.7745 12.6923 24.9361 12.923 24.9361 13.1923V15.6153H24.8957ZM27.9651 30.1538V0H18.1854H9.65847H9.416V30.1154H0V31H9.82012L27.1629 30.9691V0.884615H27.0356V31H36.3304V30.1154H27.9651V30.1538Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedRoom);
export default __webpack_public_path__ + "static/media/closedRoom.9bb2b083d30fe42c784b9453195366e9.svg";
export { ForwardRef as ReactComponent };